import BAboutSubscriptionInner from './BAboutSubscriptionInner'

export default BAboutSubscriptionInner
